import { render, staticRenderFns } from "./orderDet.vue?vue&type=template&id=09ceb743&scoped=true"
import script from "./orderDet.vue?vue&type=script&lang=js"
export * from "./orderDet.vue?vue&type=script&lang=js"
import style0 from "./orderDet.vue?vue&type=style&index=0&id=09ceb743&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ceb743",
  null
  
)

export default component.exports